export default __webpack_public_path__ + "static/media/app_overview_1.f26042b7.svg";